/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  'backbone',
  'underscore'
], function(
  Backbone,
  _
)
{

  function SimpleGuard(env, expr) {
    this.env = env;
    this.expr = expr;
    var simpleIdentRegex = /^[$A-Z_][0-9A-Z_$]*/i;
    if (typeof expr == "string") {
      var varNameMatch = expr.trim().match(simpleIdentRegex);
      if (varNameMatch) {
        this.varName = varNameMatch[0];
        if (this.env) {
          this.env.refVariable(this.varName);
        }
      }
    }
    this.listenTo(env, "change", this.evaluate);
    this.evaluate();
  }


  _.extend(SimpleGuard.prototype, Backbone.Events, {

    evaluate: function() {
      
      var newValue = false;
      try {
        newValue = this.env.evaluate(this.expr) ? true : false;
      } catch (e) {
        console.warn("Failed to evaluate expr " + this.expr);
      }
      if (this.value !== undefined || this.value != newValue) {
        this.value = newValue;
        if (this.value) {
          this.trigger("enable", this, this.value);
        }
        else {
          this.trigger("disable", this, this.value);
        }
      }
      return this.value;
    },

    setEnableAction: function(cb) {
      // if we later change to enblaed state then call cb.
      this.on("enable", cb);
      if (this.value) {
        cb();
      }
    },

    setDisableAction: function(cb) {
      // if we later change to disable state then call cb.
      this.on("disable", cb);
      if (!this.value) {
        cb();
      }
    },
    
    destroy: function() {
      this.stopListening();
      if (this.varName && this.env) {
        this.env.unrefVariable(this.varName);
      }
    }
  });
  return SimpleGuard;
});
